module.exports = __webpack_public_path__ + "img/c00_buildingtechshieldtruss_Normal_ua.ac4bdee5.webp";